import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { RidePhotos } from './ride-photos';
import { getTableParams } from './grid.params';

export const RideGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, isPlate } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const showParkingCardAction = (row) => {
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];
  actions.push({ title: t('buttons.Перейти в карточку парковки'), action: showParkingCardAction, isVisible: (row) => !!row.stay_id });

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }
  const tableParams = useMemo(() => getTableParams(t, isPlate), [t, isPlate]);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Проезды')}
        actions={actions}
        rows={{ count, items }}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClickCmp={RidePhotos}
        {...tableParams}
      />
    </GridBox>
  );
};
